import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import {axios} from '../Api';
import filter from 'lodash/filter';

export default class FileUpload extends Component {
    static propTypes = {
        uploadContext: PropTypes.string,
        dropMessage: PropTypes.string,
        onUploadsSelected: PropTypes.func,
        onUploadStarted: PropTypes.func,
        onUploadError: PropTypes.func,
        onUploadProgress: PropTypes.func,
        onUploadFinished: PropTypes.func,
        onValidateFile: PropTypes.func,
        onConfirmUpload: PropTypes.func,
        children: PropTypes.node
    };

    static defaultProps = {
        dropMessage: 'Drop Files to Upload!'
    };

    onDrop = (rawFiles) => {
        if (this.props.onConfirmUpload) {
            this.props.onConfirmUpload(rawFiles, this.upload);
        } else {
            this.upload(rawFiles);
        }
    };

    upload = (rawFiles) => {
        if (this.props.onUploadsSelected) {
            this.props.onUploadsSelected(rawFiles);
        }
        rawFiles.forEach(async (rawFile) => {
            if (this.props.onValidateFile && !this.props.onValidateFile(rawFile)) {
                return;
            }
            let id;
            try {
                const response = await axios.post(`/app/api/fileupload/start?context=${this.props.uploadContext}`);
                id = response.data.id;
                if (this.props.onUploadStarted) {
                    this.props.onUploadStarted(id, response, rawFile);
                }

                const formData = new FormData();
                formData.append('id', id);
                formData.append('file', rawFile);
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                };
                if (this.props.onUploadProgress) {
                    config.onUploadProgress = (e) => this.props.onUploadProgress(id, e.percent, rawFile);
                }

                await axios.post('/app/api/fileupload/upload', formData, config);
                if (this.props.onUploadFinished) {
                    this.props.onUploadFinished(id, rawFile);
                }

            } catch (error) {
                if (this.props.onUploadError) {
                    this.props.onUploadError(error, rawFile, id);
                }
            }
        });
    };

    onPaste = (event) => {
        const items = (event.clipboardData || event.originalEvent.clipboardData).items;
        const rawFiles = filter(items, {kind: 'file'})
            .map((item) => (
                {...item.getAsFile(),
                    lastModifiedDate: new Date(),
                    name: event.clipboardData.getData('text/plain')})
            );
        this.onDrop(rawFiles);
    };

    open = () => {
        this.dropzone.open();
    };

    render() {
        const { uploadContext, dropMessage, onUploadStarted, onUploadProgress, onUploadFinished, onValidateFile, onConfirmUpload, onUploadError, onUploadsSelected, ...dzProps } = this.props;
        return (
            <Dropzone
                {...dzProps}
                ref={ c => this.dropzone = c }
                activeClassName="dropzoneArea dropzoneAreaActive"
                onDrop={this.onDrop}
                onPaste={this.onPaste}>
                <div className="dropzoneOverlay" onPaste={this.onPaste}>
                    <h1 className="dropzoneOverlayText">
                        {this.props.dropMessage}
                    </h1>
                </div>
                {this.props.children}
            </Dropzone>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/FileUpload.js